<template>
  <el-drawer size="520px"
             :withHeader="false"
             :visible.sync="examineVisible"
             :close-on-press-escape="false"
             :wrapperClosable="false"
             :before-close="handleClickClose">
    <div class="drawer_wrap">
      <div class="drawer_header">
        <h3 class="title">认证审核</h3>
        <i class="el-icon-close" @click="handleClickClose"></i>
      </div>
      <div class="drawer_body" v-loading="loading">
        <el-form label-position="top" ref="companyForm"  size="small">
          <el-form-item label="企业名称：" prop="company_name">
            <div v-text="companyForm.auth_company_name"></div>
          </el-form-item>
          <el-form-item label="统一社会信用代码：" prop="credit_code">
            <div v-text="companyForm.credit_code"></div>
          </el-form-item>
          <el-form-item label="上传营业执照：" prop="business_license">
            <div class="upload_btn_wrap">
              <div class="upload_img_wrap">
                <el-image class="img" :src="companyForm.business_license" alt="" v-if="companyForm.business_license" :preview-src-list="[companyForm.business_license]"></el-image>

              </div>
            </div>
          </el-form-item>

          <el-form-item label="法定代表人姓名：" prop="legal_name">
            <div v-text="companyForm.legal_name"></div>
          </el-form-item>
          <el-form-item label="法定代表人身份证号码：" prop="legal_idcard">
            <div v-text="companyForm.legal_idcard"></div>

          </el-form-item>

          <el-form-item label="上传法人身份证照片：" prop="in_photo">
            <div class="upload_flex">

              <template v-for="photo in companyForm.legal_idphoto">
                <div class="upload_btn_wrap" v-if="photo.type == 'ago'">
                  <div class="upload_img_wrap">
                    <el-image class="img" :src="photo.file_path" alt="" v-if="photo.file_path"  :preview-src-list="[photo.file_path]"> </el-image>
                  </div>
                </div>
                <div class="upload_btn_wrap" v-if="photo.type == 'back'">
                  <div class="upload_img_wrap">
                    <el-image class="img" :src="photo.file_path" alt="" v-if="photo.file_path" :preview-src-list="[photo.file_path]"> </el-image>
                  </div>
                </div>
              </template>
            </div>

          </el-form-item>
        </el-form>
      </div>
      <div class="drawer_footer">
        <el-button size="small" @click="handleClickRefuse" type="danger" plain>拒绝</el-button>
        <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">同意</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>

import { authDetails ,authAudit} from '@/api'
export default {
  name: 'examine',
  props: {
    examineVisible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      companyForm: {
        company_id:'',
        id:'',
        company_logo:'',
        company_name:'',
        industry_type:'',
        industry_type_sub:'',
        personnel_size:'',
        province:'',
        city:'',
        area:'',
        addr:'',
        contact_name:'',
        contact_phone:'',
        position:'',
        company_tel:'',
        company_email:'',
        auth_status:'',
        legal_idphoto:[]
      },
    }
  },
  computed: {

  },
  mounted() {
    if(this.companyId && this.companyId !=0){
      this.getAuthDetails()
    }
  },
  methods: {
    getAuthDetails(){
      authDetails({
        company_id: this.companyId
      }).then(res => {
        if (res.code === 200) {
          this.companyForm = res.data
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    //取消事件
    handleClickClose() {
      //关闭对话框
      this.$emit('update:examineVisible', false)
    },

    // 拒绝
    handleClickRefuse(){
      this.$prompt('拒绝原因', '拒绝认证审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputType:'textarea',
        closeOnClickModal:false,
        inputErrorMessage: '请输入拒绝原因'
      }).then(({value}) => {
        authAudit({
          company_id: this.companyId,
          auth_status: 3,
          auth_msg: value,
        }).then(res => {
          if (res.code === 200) {
            // 验证通过调用新增菜单接口
            this.$message.success('操作成功')
            //调用取消事件
            this.handleClickClose()
            //父页面刷新列表
            this.$emit('success')
          }else{
            this.$message.error(res.message)
          }
        })

      }).catch(() => {

      })
    },
    //确定事件
    handleClickConfirm() {
      this.$confirm('确定同意认证审核吗，是否继续？', {
        closeOnClickModal: false,
        closeOnPressEscape: false,
        confirmButtonText: '确定',
        customClass: 'title_icon_message_box'
      }).then(() => {
        authAudit({
          company_id: this.companyId,
          auth_status: 1,
        }).then(res => {
          if (res.code === 200) {
            // 验证通过调用新增菜单接口
            this.$message.success('操作成功')
            //调用取消事件
            this.handleClickClose()
            //父页面刷新列表
            this.$emit('success')
          }else{
            this.$message.error(res.message)
          }
        })
      }).catch(() => {

      })
    },
  },

}
</script>
<style lang="scss" scoped>
.upload_flex{
  display: flex;
}
.upload_btn_wrap{
  width: 144px;
  height: 90px;
  position: relative;
  border-radius: 4px;
  border: 1px solid rgba(209, 228, 239, 1);
  box-sizing: border-box;
  overflow: hidden;
  margin-right: 24px;
}

.upload_btn_wrap .upload_img_wrap{
  width: 100%;
  position: relative;
  border: none;
}
.upload_btn_wrap .upload_img_wrap .img{
  display: block;
  width: 100%;
  height: 88px;
  object-fit: cover;
}
</style>
